import { createSlice } from "@reduxjs/toolkit";
import { initialProjectList } from "@utils/builderUtils";
import { Actions } from "@typedefs/interfaces";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { TopbarStep } from "@typedefs/interfaces";
import type { RootState } from "@app/store";
import type { BIntactMapState, Builder, ResultsTab } from "./builderTypes";

const initialState: Builder = {
  tabsOpen: true,
  resultsTab: "ghg",
  activeAction: Actions.LiveUpdates,
  actionsList: [],
  moduleList: [],
  projectList: initialProjectList,
  isFetchingData: false,
  currentModuleThreads: [],
  activeThread: null,
  selectedLanguage: 'en',
  bIntactMapState: null
}

export const BuilderSlice = createSlice({
  name: "builder",
  initialState,
  reducers: {
    setBuilder: (state, action: PayloadAction<Builder>) => {
      const { projectList, tabsOpen } = action.payload;
      state.projectList = projectList
      state.tabsOpen = tabsOpen
    },
    toggleTabsOpen: (state, action: PayloadAction<undefined | boolean>) => { state.tabsOpen = action.payload !== undefined ? action.payload : !state.tabsOpen },
    setModuleList: (state, action: PayloadAction<TopbarStep[]>) => { state.moduleList = action.payload },
    setActionList: (state, action: PayloadAction<Actions[]>) => { state.actionsList = action.payload },
    setActiveAction: (state, action: PayloadAction<Actions>) => { state.activeAction = action.payload },
    setIsFetchingData: (state, action: PayloadAction<boolean>) => { state.isFetchingData = action.payload },
    setCurrentModuleThreads: (state, action: PayloadAction<number[]>) => { state.currentModuleThreads = action.payload },
    setActiveThread: (state, action: PayloadAction<number | null>) => { state.activeThread = action.payload },
    setSelectedLanguage: (state, action: PayloadAction<string>) => { state.selectedLanguage = action.payload },
    setBIntactMapState: (state, action: PayloadAction<BIntactMapState | null>) => { state.bIntactMapState = action.payload },
    setResultsTab: (state, action: PayloadAction<ResultsTab>) => { state.resultsTab = action.payload },
  }
})

export const {
  setBuilder,
  setActiveAction,
  setResultsTab,
  toggleTabsOpen,
  setModuleList,
  setIsFetchingData,
  setActionList,
  setActiveThread,
  setCurrentModuleThreads,
  setSelectedLanguage,
  setBIntactMapState,
} = BuilderSlice.actions

export const selectCurrentBuilder = (state: RootState) => state.builder;
export const selectCurrentActions = (state: RootState) => state.builder.actionsList;
export const selectIsFetchingData = (state: RootState) => state.builder.isFetchingData;
export const selectActiveThread = (state: RootState) => state.builder.activeThread;
export const selectCurrentModuleThreads = (state: RootState) => state.builder.currentModuleThreads;
export const selectSelectedLanguage = (state: RootState) => state.builder.selectedLanguage;
export const selectBIntactMapState = (state: RootState) => state.builder.bIntactMapState;

export default BuilderSlice.reducer; 